
















import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { AcgnProjectList } from '@/components/';
import { AcgnLeftMenu  } from './components/';
import { AttributeMixin, RenderMenuMixin } from '@/mixins';

import {
  AcgnTopButton,
} from '@acgn/herm/src/ui';
import { displayFormValidationError } from '@acgn/herm/src/util/form';
import event from '@acgn/herm/src/util/event';

const ComicAction = namespace('desk/comic').Action;

interface SearchType { // 项目搜索字段
  name?: string; // 项目名称
  username?: string; // 创建人名称
  page?: number; // 当前页码
}

// 组件申明
@Component({
  components: {
    AcgnTopButton,
    AcgnProjectList,
    AcgnLeftMenu
  },
  mixins: [AttributeMixin, RenderMenuMixin]
})

/**
 * 项目列表
 */
export default class ComicList extends Vue {

  @ComicAction private getComicList: any; // 获取漫画项目列表(画手工作台)
  @ComicAction private getProjectByStatus: any; // 获取漫画项目列表(项目列表)

  private isProject: any = false;

  private async created() {
    if (this.$route.path === '/desk/comic-auth/list') {
      this.isProject = true;
    }
  }
  // 列表方法
  private async getList(options: any) {
    if (this.isProject) {
      return this.getProjectByStatus(options);
    }
    return this.getComicList(options);
  }

  private renderPic(row: any) {
    return (
      <img src={(window as any).configs.imageDomain + row.icon} style="width:50px;height:50px;" />
    );
  }

  // 渲染左侧菜单
  private renderMenu() {
    return (
      <acgn-left-menu isProject={this.isProject} />
    );
  }

  // 列表操作项
  private onListAction(item: any) {
    switch (item.type) {
      case 'delete':
        // this.delete(item.row);
        break;
    }
  }

}
